import { AxiosResponse } from 'axios'

import { rawTransform } from 'src/services/skuit/utils'
import { Context, Generic } from '../../api/models'

import { API, CustomAxiosConfig } from './types'

export interface ScanResult {
  scanned: Generic
  context: any
}

export class Lookup {
  api: API

  constructor(api: API) {
    this.api = api
  }

  async ident(config: CustomAxiosConfig = {}): Promise<[ScanResult, AxiosResponse]> {
    const response = await this.api.get('/lookup/scan', config)
    response.data.scanned = rawTransform(Generic)(response.data.scanned)
    if (response.data.context) {
      response.data.context = rawTransform(Context)(response.data.context)
    }
    return [response.data, response]
  }
}
